import { render, staticRenderFns } from "./exchange-gifts.vue?vue&type=template&id=fb06c6e8&scoped=true&"
import script from "./exchange-gifts.vue?vue&type=script&lang=js&"
export * from "./exchange-gifts.vue?vue&type=script&lang=js&"
import style0 from "./exchange-gifts.vue?vue&type=style&index=0&id=fb06c6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb06c6e8",
  null
  
)

export default component.exports